import React, {useState,useEffect,useCallback} from 'react'
import styled from 'styled-components'
import { Text, Link, ButtonMenu, ButtonMenuItem } from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'
import Page from 'components/layout/Page2'
import Hero from './components/Hero'
import BridgeCore from './components/BridgeCore'
import ManualClaim from './components/ManualClaim'

const Wrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 25px 0px 35px 0px;
`

const Bridge = () => {
    const TranslateString = useI18n();
    const [activeIndex, setActiveIndex] = useState(0);
    const handleClick = (index) => {
        setActiveIndex(index)
    }


    return (
        <>
            <Hero/>
            <Page>
                <Wrapper>
                    <ButtonMenu activeIndex={activeIndex} onClick={handleClick} size="sm" variant="subtle">
                        <ButtonMenuItem>{TranslateString(2039,'Bridge')}</ButtonMenuItem>
                        <ButtonMenuItem>{TranslateString(2027,'Manual Claim')}</ButtonMenuItem>
                    </ButtonMenu>
                </Wrapper>
                <div style={activeIndex===0?{}:{display:"none"}}>
                    <BridgeCore/>
                </div>
                <div style={activeIndex===1?{}:{display:"none"}}>
                    <ManualClaim/>
                </div>
            </Page>
        </>
    )
}

export default Bridge
